export function importTagConfig(teamTags = [], setup = {}) {
  const priced = new Set([...Object.keys(setup.tagOverrides || {}), ...Object.keys(setup.tagOverridesYearly || {})]);
  const ageTags = new Set(teamTags.filter(tag => tag?.type === 'ageRule').flatMap(tag => Array.isArray(tag.tagNames) ? tag.tagNames : [tag.tagName]).filter(Boolean));
  const tags = teamTags.filter(tag => tag?.type !== 'ageRule' && tag?.name && !priced.has(tag.name) && !ageTags.has(tag.name));
  const requiredGroups = new Map();
  teamTags.forEach(tag => {
    if (tag?.type === 'ageRule' || !tag?.name || tag.requiredForMembers !== true || tag.visibleToMembers === false || tag.selfAssignable !== true) return;
    const category = String(tag.category || '').trim() || 'Uncategorised';
    if (!requiredGroups.has(category)) requiredGroups.set(category, { category, names: [], pricing: false });
    const group = requiredGroups.get(category);
    group.names.push(tag.name);
    if (priced.has(tag.name)) group.pricing = true;
  });
  return { tags, priced, ageTags, requiredGroups: Array.from(requiredGroups.values()) };
}

export function previewMigrationTagIssues({ parsed, columnMap, membershipMappings, teamTags, setup, deferNonPricing = false, collectOnly = false }) {
  const config = importTagConfig(teamTags, setup);
  const known = new Set([...teamTags.map(tag => tag?.name).filter(Boolean), ...config.ageTags]);
  const categories = new Map(teamTags.filter(tag => tag?.type !== 'ageRule' && tag?.name).map(tag => [tag.name, String(tag.category || '').trim() || 'Uncategorised']));
  const problems = new Map();
  const add = (source, problem) => {
    const key = JSON.stringify([source, problem]);
    const existing = problems.get(key);
    if (existing) existing.count += 1;
    else problems.set(key, { source, problem, count: 1 });
  };
  for (const row of parsed?.rows || []) {
    const source = row.values[columnMap.legacyMembership] || '';
    const mapping = membershipMappings[source];
    if (!mapping?.kind || mapping.kind === 'exclude') continue;
    const csvTags = String(row.values[columnMap.tags] || '').split(/[;|]/).map(value => value.trim()).filter(Boolean);
    const csvCategories = new Set(csvTags.filter(tag => !config.priced.has(tag) && !config.ageTags.has(tag)).map(tag => categories.get(tag)));
    const defaults = (mapping.tags || []).filter(tag => !csvCategories.has(categories.get(tag)));
    const combined = [...csvTags, ...defaults];
    const unknown = combined.filter(tag => !known.has(tag));
    if (unknown.length && !collectOnly) add(source, `Unknown tags: ${Array.from(new Set(unknown)).join(', ')}. Use the club’s exact tag names.`);
    const selected = new Set(combined.filter(tag => !config.priced.has(tag) && !config.ageTags.has(tag)));
    if (mapping.kind === 'tag') selected.add(mapping.value);
    for (const group of config.requiredGroups) {
      if (mapping.kind === 'family' && group.pricing) continue;
      if ((collectOnly && group.pricing) || (!collectOnly && deferNonPricing && !group.pricing)) continue;
      if (!group.names.some(name => selected.has(name))) {
        const ordinaryOptions = group.names.filter(name => !config.priced.has(name) && !config.ageTags.has(name));
        add(source, collectOnly ? `${group.category}: member completes when claiming.` : ordinaryOptions.length ? `Choose a tag in ${group.category}, or supply it in the Tags column.` : `Choose a priced membership option above for ${group.category}.`);
      }
    }
  }
  return Array.from(problems.values());
}

export const previewMigrationTagCollection = args => previewMigrationTagIssues({ ...args, collectOnly: true });
